import { render, staticRenderFns } from "./VerDetalleMensaje.vue?vue&type=template&id=3771e9d8&"
import script from "./VerDetalleMensaje.vue?vue&type=script&lang=ts&"
export * from "./VerDetalleMensaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3771e9d8', component.options)
    } else {
      api.reload('3771e9d8', component.options)
    }
    module.hot.accept("./VerDetalleMensaje.vue?vue&type=template&id=3771e9d8&", function () {
      api.rerender('3771e9d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/CopilotoVirtual/Mensaje/VerDetalleMensaje.vue"
export default component.exports